const EXCLUDED_PATHS = ["/support", "/careers", "/signup"] as const;

export default function isQualifiedEnabled(pathname: string) {
  return !EXCLUDED_PATHS.some((excludedPath) =>
    pathname?.startsWith(excludedPath),
  );
}
